<template>
  <div class="historyCardList">
    <div class="title">历史记录</div>
    <div class="list">
      <el-card v-for="(item,index) in histories" :key="index" shadow="hover" @click.native="cardClick(item)">
        <div class="name">{{ item.programmeName }}</div>
        <div class="info">{{ item.subtaskName }}</div>
        <div class="info">{{ item.customerName }} {{ item.domain }}</div>
        <div class="info">{{ item.modifierName }} 最后操作于 {{ item.modifiedTimeStr }}</div>
      </el-card>
    </div>

  </div>
</template>
<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: 'historyCardList',
  props: {
    histories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      aiModel: state => state.aiAds.aiModel,
    })
  },
  methods: {
    ...mapMutations(['setCurrentPage', 'setCurrentInfo', 'setModel']),
    cardClick(item) {
      if (item.programmeType === 2) {
        this.setModel(2);
        this.setCurrentInfo({
          programmeId: item.programmeId, // ai广告方案信息ID
          serviceId: item.serviceId, // 服务单ID
          customerId: item.customerId, // 客户ID
        })
      } else if (item.programmeType === 1) {
        this.setModel(1);
        this.setCurrentInfo({
          programmeId: item.programmeId, // ai广告方案信息ID
        })
      }
      this.setCurrentPage(2)
    }
  }
}
</script>
<style lang="scss" scoped>
.historyCardList {
  .title {
    border-left: 5px solid #52a4f8;
    box-sizing: border-box;
    padding-left: 5px;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .list {
    display: flex;
    justify-content: flex-start;

    flex-wrap: wrap;

    .el-card {
      width: 400px;
      height: 100px;
      margin-bottom: 20px;
      margin-right: 10px;

      .name {
        font-size: 14px;

      }

      .info {
        color: #999;
        font-size: 12px;
        line-height: 18px;
      }

    }
  }
}

</style>